/**
 * Static SEO metadata + rich content for individual treatment detail pages.
 * Only real treatments the practice actually offers.
 */

export const TREATMENTS = {
  abhyanga: {
    slug: "abhyanga",
    dbSlug: "abhyanga",
    durationMin: 60,
    priceChf: 120,
    de: {
      title: "Abhyanga Massage Aargau – Ayurveda-Ganzkörper­behandlung",
      metaDescription:
        "Traditionelle Abhyanga Ganzkörpermassage im Aargau. 60 Min für CHF 120. Praxis für Frauen in Sarmenstorf & Rupperswil. Termin online buchen.",
      h1: "Abhyanga Massage Aargau – Die klassische ayurvedische Ölmassage",
      lead:
        "Abhyanga ist die Königin der ayurvedischen Massagen. In unserer Praxis für Frauen im Aargau erhältst du eine 60-minütige Ganzkörper­behandlung mit warmem, konstitutions­gerechtem Öl – tiefe Entspannung, messbarer Stressabbau, spürbare Wirkung ab der ersten Sitzung.",
      sections: [
        {
          h2: "Wirkung der Abhyanga Massage",
          body: [
            "Die Wirkung der Abhyanga entfaltet sich auf drei Ebenen: körperlich, energetisch und mental. Körperlich: warmes Öl löst Verspannungen, verbessert die Durchblutung, unterstützt Lymphfluss und Entgiftung. Studien zeigen, dass der Cortisol-Spiegel (Stresshormon) während einer Abhyanga um 20-30 % sinkt, während die Herzratenvariabilität steigt.",
            "Energetisch beruhigt Abhyanga vor allem das Vata-Dosha – die Energie der Bewegung und der Nerven. Menschen mit hohem Vata-Anteil profitieren besonders: die Behandlung erdet, wärmt und beruhigt. Mental entsteht durch die 60 Minuten rhythmischer Berührung ein Zustand tiefer Ruhe, der oft tagelang anhält.",
            "Typische Wirkungen unserer Kundinnen: besserer Schlaf ab der ersten Nacht, weniger Grübeln, warme Extremitäten, ausgeglichenere Verdauung, mehr Geduld im Alltag. Bei chronischem Stress empfehlen wir 3 Behandlungen im Wochenabstand.",
          ],
        },
        {
          h2: "Ablauf einer Abhyanga Behandlung",
          body: [
            "Deine Behandlung beginnt mit einem kurzen Vorgespräch (5-10 Min). Wir klären deinen aktuellen Zustand, dein Ziel und mögliche Kontraindikationen. Danach wählen wir gemeinsam das passende Öl aus – meist eine Kombination aus Sesam, Kokos oder speziellen Kräuterölen, abgestimmt auf deine Konstitution.",
            "Für die Behandlung entkleidest du dich bis auf die Unterwäsche und legst dich auf unsere beheizte Ayurveda-Liege. Du wirst mit warmen Tüchern zugedeckt, es wird immer nur die aktuell behandelte Körperpartie freigelegt. Das Öl wird auf Körpertemperatur erwärmt und in langen, rhythmischen Bewegungen einmassiert – von den Füssen aufwärts, über Beine, Bauch, Arme, Rücken, Nacken bis zum Kopf.",
            "Zu Beginn und zum Abschluss der Behandlung begleiten wir dich mit tibetischen, indischen und nepalesischen Klangschalen. Nach der Massage folgt eine 10-minütige Nachliegezeit, dann ein warmer Ayurveda-Tee.",
          ],
        },
        {
          h2: "Für wen eignet sich Abhyanga?",
          body: [
            "Abhyanga ist eine der sanftesten und gleichzeitig tiefgreifendsten Behandlungen des Ayurveda. Sie eignet sich für nahezu jede Frau in nahezu jeder Lebens­phase.",
          ],
          list: [
            "Bei chronischem Stress, Burnout-Neigung und Erschöpfung",
            "Bei Schlafstörungen, besonders unruhigem Schlaf und frühem Aufwachen",
            "Bei muskulären Verspannungen in Nacken, Schultern und Rücken",
            "Bei kalten Händen und Füssen, unruhiger Verdauung (Vata-Symptome)",
            "In der Wechseljahres­zeit zur Beruhigung von Unruhe und Hitzewallungen",
            "Als regelmässige Pflege für Frauen mit fordernden Berufen oder Care-Verpflichtungen",
          ],
        },
        {
          h2: "Preise & Dauer",
          body: [
            "**60 Minuten · CHF 120** – inklusive Vorgespräch, warmem Ayurveda-Öl, Klangschalen-Ritual, Nachliegezeit und Ayurveda-Tee.",
            "Bezahlt wird bequem vor Ort in bar, per Twint oder Kreditkarte. Bei Buchung von 3 oder mehr Terminen gewähren wir 10-15 % Rabatt – schreib uns dazu einfach «PAKET» auf WhatsApp.",
          ],
        },
        {
          h2: "Abhyanga Termin in Aargau buchen",
          body: [
            "Du findest uns an zwei Standorten im Aargau: **Sarmenstorf** (Obere Feldeggstr. 13, zentral im Seetal – 15 Min von Aarau, Lenzburg, Wohlen) und **Rupperswil** (Aarestrasse 20 – direkt beim Bahnhof, ideal für Kundinnen aus Aarau, Suhr und dem Raum Zürich).",
            "Termine gibt es Montag bis Samstag zwischen 09:00 und 22:00 Uhr, ausschliesslich nach Voranmeldung.",
          ],
        },
      ],
      faqs: [
        {
          q: "Wie oft sollte ich eine Abhyanga machen?",
          a: "Für nachhaltige Wirkung bei Stress empfehlen wir 3 Behandlungen im Wochenabstand. Anschliessend reicht eine monatliche Erhaltungs-Behandlung.",
        },
        {
          q: "Was ziehe ich zur Behandlung an?",
          a: "Du entkleidest dich bis auf die Unterwäsche. Wir empfehlen für den Heimweg dunkle, bequeme Kleidung, da noch etwas Öl auf der Haut zurückbleibt (das ist gewollt und wirkt nach).",
        },
        {
          q: "Kann ich nach der Massage direkt Auto fahren?",
          a: "Ja, aber wir empfehlen eine kurze Pause von 15-20 Minuten. Die tiefe Entspannung kann die Reaktions­fähigkeit vorübergehend verlangsamen.",
        },
        {
          q: "Übernimmt die Krankenkasse die Kosten?",
          a: "Nein. Ayurveda Aargau ist nicht krankenkassen­anerkannt. Die Behandlung ist eine Wellness- und Entspannungs­leistung.",
        },
        {
          q: "Kann ich Abhyanga in der Schwangerschaft machen?",
          a: "Ja, ab dem 2. Trimester und mit angepasster Technik. Bitte kontaktiere uns vorab, damit wir die Behandlung optimal auf dich abstimmen.",
        },
      ],
    },
    en: {
      title: "Abhyanga Massage Aargau – Ayurvedic Full-Body Treatment",
      metaDescription:
        "Traditional Abhyanga full-body massage in Aargau. 60 min for CHF 120. Women-only practice in Sarmenstorf & Rupperswil. Book online.",
      h1: "Abhyanga Massage Aargau – The Classical Ayurvedic Oil Massage",
      lead:
        "Abhyanga is the queen of ayurvedic massages. In our women-only practice in Aargau you receive a 60-minute full-body treatment with warm, constitution-matched oil — deep relaxation, measurable stress relief, effect from the first session.",
      sections: [
        {
          h2: "Effect of the Abhyanga Massage",
          body: [
            "Abhyanga works on three levels: physical, energetic and mental. Physically: warm oil releases tension, improves circulation, supports lymph flow and detoxification. Studies show cortisol drops 20-30 % during Abhyanga while heart-rate variability rises.",
            "Energetically Abhyanga calms Vata dosha – the energy of movement and nerves. Women with high Vata benefit most: it grounds, warms and calms. Mentally the 60 minutes of rhythmic touch create a deep calm often lasting days.",
            "Common effects our clients report: better sleep from night one, less rumination, warm hands and feet, more balanced digestion, more patience in daily life. For chronic stress we recommend 3 sessions one week apart.",
          ],
        },
        {
          h2: "How an Abhyanga session flows",
          body: [
            "Your session starts with a short intake (5-10 min). We understand your current state, your goal and any contraindications. Then we choose the right oil – usually a blend of sesame, coconut or specific herbal oils matched to your constitution.",
            "For the treatment you undress down to underwear and lie on our heated Ayurveda bed. You'll be covered with warm sheets, only the currently treated area is exposed. The oil is warmed to body temperature and worked in with long rhythmic strokes – from feet upward, over legs, belly, arms, back, neck and head.",
            "Tibetan, Indian and Nepalese singing bowls open and close the treatment. After the massage you rest for 10 minutes with a warm Ayurveda tea.",
          ],
        },
        {
          h2: "Who is Abhyanga for?",
          body: ["Abhyanga is among the gentlest and simultaneously deepest treatments of Ayurveda. It suits almost every woman in almost every life phase."],
          list: [
            "Chronic stress, burnout tendency, exhaustion",
            "Sleep disturbances, especially restless sleep and early waking",
            "Muscular tension in neck, shoulders and back",
            "Cold hands and feet, restless digestion (Vata symptoms)",
            "Menopause phase to calm restlessness and hot flashes",
            "Regular self-care for women with demanding careers or care duties",
          ],
        },
        {
          h2: "Price & Duration",
          body: [
            "**60 minutes · CHF 120** — includes intake, warm ayurvedic oil, singing bowl ritual, rest time and Ayurveda tea.",
            "Payment on site by cash, Twint or credit card. For 3+ session bookings we offer 10-15 % off – just message «PAKET» on WhatsApp.",
          ],
        },
        {
          h2: "Book your Abhyanga in Aargau",
          body: [
            "You'll find us at two Aargau locations: **Sarmenstorf** (Obere Feldeggstr. 13, central Seetal – 15 min from Aarau, Lenzburg, Wohlen) and **Rupperswil** (Aarestrasse 20 – right by the station, ideal for Aarau, Suhr and greater Zurich).",
            "Available Monday to Saturday 09:00-22:00 by appointment only.",
          ],
        },
      ],
      faqs: [
        { q: "How often should I get Abhyanga?", a: "For lasting stress-relief effect, 3 sessions at weekly intervals. Then monthly maintenance is enough." },
        { q: "What do I wear during treatment?", a: "You undress to underwear. Wear comfortable dark clothes for the way home – some oil remains on the skin (this is intentional and continues to work)." },
        { q: "Can I drive right after?", a: "Yes, but we recommend a 15-20 minute break. Deep relaxation can temporarily slow reaction time." },
        { q: "Is this covered by health insurance?", a: "No. Ayurveda Aargau is not recognised by Swiss health insurance. The treatment is a wellness and relaxation service." },
        { q: "Can I have Abhyanga during pregnancy?", a: "Yes, from the second trimester with adapted technique. Please contact us in advance so we can tailor the session for you." },
      ],
    },
  },
};

/** Location landing pages */
export const LOCATIONS = {
  aarau: {
    slug: "aarau",
    de: {
      title: "Ayurveda Massage Aarau – Nur 15 Min entfernt in Sarmenstorf",
      metaDescription:
        "Suchst du Ayurveda-Massage in Aarau? Unsere Praxis für Frauen ist in Sarmenstorf (15 Min) und Rupperswil (10 Min beim Bahnhof). Termin online buchen ab CHF 60.",
      h1: "Ayurveda Massage Aarau – Nur 15 Minuten von der Altstadt entfernt",
      lead:
        "Du suchst nach ayurvedischer Massage in Aarau? Unsere Praxis für Frauen liegt zwar nicht direkt in der Altstadt, dafür ganz nah dran: **Sarmenstorf** (15 Min via A1 oder Kantonsstrasse) und **Rupperswil** (10 Min mit Auto, S-Bahn ab Bahnhof Aarau nur 6 Min). Für Aarauerinnen die ideale Kombination aus stadtnaher Erreichbarkeit und ländlicher Ruhe.",
      sections: [
        {
          h2: "Warum wir bewusst nicht in der Innenstadt Aarau sind",
          body: [
            "Ayurveda wirkt am besten in einer ruhigen, ungestörten Umgebung. Unsere Praxis in Sarmenstorf liegt in einer stillen Wohnstrasse mit Blick ins Grüne, unsere Zweitpraxis in Rupperswil direkt am Rand des Aare-Ufers. Beide Standorte lassen dich schon beim Ankommen abschalten – das ist Teil der Wirkung.",
            "Nach einer 60-minütigen [Abhyanga-Massage](/behandlungen/abhyanga) oder einer [Klangschalen-Behandlung](/klangschalen) willst du nicht sofort wieder in den Aarauer Verkehr eintauchen. Bei uns kannst du in Ruhe nachliegen, einen Ayurveda-Tee trinken und dann ganz gemütlich zurück fahren.",
          ],
        },
        {
          h2: "Anfahrt aus Aarau",
          body: [
            "**Mit dem Auto nach Sarmenstorf** (Obere Feldeggstr. 13, 5614 Sarmenstorf): Ab Aarau Altstadt ca. 15 Min über A1 Richtung Zürich, Ausfahrt Mägenwil, dann Kantonsstrasse Richtung Wohlen. Parkplätze direkt vor dem Haus.",
            "**Mit dem Auto nach Rupperswil** (Aarestrasse 20, 5102 Rupperswil): Ab Aarau ca. 10 Min über Buchserstrasse. Parkplätze in der Umgebung vorhanden.",
            "**Mit ÖV nach Rupperswil**: Ab Bahnhof Aarau mit der S-Bahn S3/S12 nach Rupperswil (6 Min Fahrzeit), dann 3 Min zu Fuss.",
          ],
        },
        {
          h2: "Behandlungen für Aarauerinnen",
          body: ["Alle unsere ayurvedischen Behandlungen sind an beiden Standorten verfügbar:"],
          list: [
            "[Abhyanga Ganzkörper-Ölmassage](/behandlungen/abhyanga) – 60 Min · CHF 120",
            "[Kalari-Massage](/massagen) – 60 Min · CHF 120",
            "[Rückenmassage (Pristabhyanga)](/massagen) – 60 Min · CHF 120",
            "[Shiroabhyanga Kopf- und Nackenmassage](/massagen) – 30 Min · CHF 60",
            "[Padabhyanga Fussmassage](/massagen) – 30 Min · CHF 60",
            "[Garshana Trocken-Peeling](/massagen) – 45 Min · CHF 100",
            "[Ayurvedische Ernährungs­beratung](/ernaehrung) – ca. 60 Min · auf Anfrage",
          ],
        },
        {
          h2: "Für Frauen aus Aarau, Suhr, Buchs und Küttigen",
          body: [
            "Der überwiegende Teil unserer Kundinnen kommt aus dem grösseren Raum Aarau: aus der Altstadt selbst, aus Suhr, Buchs, Küttigen, Erlinsbach, Rohr und Biberstein. Der Weg zu uns ist ein Teil der Behandlung – nutze die 15 Minuten Fahrt, um schon anzukommen.",
            "Termine ausschliesslich für Frauen, Montag bis Samstag zwischen 09:00 und 22:00 Uhr nach Voranmeldung.",
          ],
        },
        {
          h2: "Termin online buchen",
          body: [
            "Wähle unter [Termin buchen](/booking) deine Wunsch­behandlung, ein Datum, eine Uhrzeit und deinen bevorzugten Standort (Sarmenstorf oder Rupperswil). Die definitive Bestätigung erhältst du innerhalb 48 Stunden per E-Mail oder Telefon.",
          ],
        },
      ],
      faqs: [
        { q: "Warum gibt es keine Praxis direkt in Aarau?", a: "Ayurveda wirkt am besten in ruhiger Umgebung. Unsere Standorte in Sarmenstorf und Rupperswil bieten Aarauerinnen alle Vorteile der Nähe (15 bzw. 10 Min) mit dem Bonus der Ruhe." },
        { q: "Wie lange dauert die Fahrt von Aarau nach Sarmenstorf?", a: "Mit dem Auto ca. 15 Minuten via A1 oder Kantonsstrasse. Parkplätze sind direkt vor der Praxis vorhanden." },
        { q: "Kann ich mit dem Zug kommen?", a: "Zur Zweigpraxis Rupperswil ja – ab Bahnhof Aarau 6 Min mit der S-Bahn, dann 3 Min zu Fuss. Nach Sarmenstorf am einfachsten mit dem Auto." },
      ],
    },
    en: {
      title: "Ayurveda Massage Aarau – Just 15 min away in Sarmenstorf",
      metaDescription:
        "Looking for Ayurveda in Aarau? Our women-only practice is in Sarmenstorf (15 min) and Rupperswil (10 min). Book online from CHF 60.",
      h1: "Ayurveda Massage Aarau – Just 15 Minutes from the Old Town",
      lead:
        "Looking for ayurvedic massage in Aarau? Our women-only practice isn't in the old town – but very close: **Sarmenstorf** (15 min by car) and **Rupperswil** (10 min by car, 6 min by S-Bahn from Aarau station). For women in Aarau the ideal combination of city access and countryside quiet.",
      sections: [
        {
          h2: "Why we're not right in the city centre",
          body: [
            "Ayurveda works best in a quiet, undisturbed environment. Our Sarmenstorf practice sits on a silent residential lane with a view of green fields; our Rupperswil branch right by the river Aare. Both let you unwind from the moment you arrive – that's part of the effect.",
            "After a 60-minute [Abhyanga](/behandlungen/abhyanga) or a [singing bowl session](/klangschalen), you won't want to plunge back into Aarau traffic. With us you can rest, sip an Ayurveda tea and drive back at your own pace.",
          ],
        },
        {
          h2: "Getting here from Aarau",
          body: [
            "**By car to Sarmenstorf** (Obere Feldeggstr. 13, 5614 Sarmenstorf): from Aarau old town about 15 min via A1 towards Zurich, exit Mägenwil, then the cantonal road towards Wohlen. Parking right at the house.",
            "**By car to Rupperswil** (Aarestrasse 20, 5102 Rupperswil): about 10 min via Buchserstrasse. Parking nearby.",
            "**By public transport to Rupperswil**: from Aarau station S-Bahn S3/S12 (6 min ride), then 3 min on foot.",
          ],
        },
        {
          h2: "Treatments for women in Aarau",
          body: ["All our ayurvedic treatments are available at both locations:"],
          list: [
            "[Abhyanga full-body oil massage](/behandlungen/abhyanga) – 60 min · CHF 120",
            "[Kalari massage](/massagen) – 60 min · CHF 120",
            "[Back massage (Pristabhyanga)](/massagen) – 60 min · CHF 120",
            "[Shiroabhyanga head & neck massage](/massagen) – 30 min · CHF 60",
            "[Padabhyanga foot massage](/massagen) – 30 min · CHF 60",
            "[Garshana dry massage](/massagen) – 45 min · CHF 100",
            "[Ayurvedic nutrition consulting](/ernaehrung) – approx. 60 min · on request",
          ],
        },
        {
          h2: "For women from Aarau, Suhr, Buchs and Küttigen",
          body: [
            "Most of our clients come from greater Aarau: from the old town, Suhr, Buchs, Küttigen, Erlinsbach, Rohr and Biberstein. The drive to us is part of the treatment – use those 15 minutes to already arrive.",
            "Women only, Monday to Saturday 09:00-22:00 by appointment.",
          ],
        },
        {
          h2: "Book your appointment online",
          body: ["At [Book appointment](/booking) choose your treatment, date, time and preferred location (Sarmenstorf or Rupperswil). Final confirmation within 48 hours by email or phone."],
        },
      ],
      faqs: [
        { q: "Why no practice directly in Aarau?", a: "Ayurveda works best in quiet surroundings. Sarmenstorf and Rupperswil give Aarau women all the benefits of nearness (15 and 10 min) with the bonus of quiet." },
        { q: "How long is the drive from Aarau to Sarmenstorf?", a: "About 15 minutes by car via A1 or the cantonal road. Parking right at the practice." },
        { q: "Can I come by train?", a: "To our Rupperswil branch yes – from Aarau station 6 min S-Bahn, then 3 min on foot. Sarmenstorf is best reached by car." },
      ],
    },
  },
  baden: {
    slug: "baden",
    de: {
      title: "Ayurveda Baden – Traditionelle Massagen für Frauen aus Baden",
      metaDescription:
        "Ayurveda für Frauen aus Baden: Praxis in Sarmenstorf (25 Min) und Rupperswil (12 Min via S-Bahn ab Baden). Termin online buchen ab CHF 60.",
      h1: "Ayurveda in Baden – Für Frauen aus der Bäderstadt",
      lead:
        "Baden gilt seit römischer Zeit als Schweizer Bäderstadt – Thermen, Kurbäder, Wellness sind hier Tradition. Wer eine ergänzende Behandlung sucht, die tiefer geht als eine klassische Massage, findet in unserer Ayurveda-Praxis für Frauen die passende Erweiterung. Wir sind nicht in Baden selbst, dafür schnell erreichbar: **Rupperswil** nur 12 Min mit der S3 ab Bahnhof Baden, **Sarmenstorf** 25 Min mit dem Auto.",
      sections: [
        {
          h2: "Ayurveda-Behandlungen für Kundinnen aus Baden",
          body: [
            "Für Frauen aus dem Raum Baden bietet sich unsere Praxis besonders an, weil sie das kombiniert, was Badekur allein nicht kann: **rhythmische Berührung mit warmem Öl**, die das autonome Nervensystem umschaltet, plus **Klangschalen-Ritual**, das die Wirkung vertieft. Alle sechs klassischen Behandlungen sind bei uns verfügbar – von der 30-minütigen Kopfmassage (CHF 60) bis zur 60-minütigen [Abhyanga-Ganzkörper­behandlung](/behandlungen/abhyanga) (CHF 120).",
          ],
        },
        {
          h2: "Anfahrt aus Baden zu unserer Praxis",
          body: [
            "**Mit der S-Bahn nach Rupperswil** (Aarestrasse 20, 5102 Rupperswil): Ab Bahnhof Baden mit der S3 direkt nach Rupperswil, ca. 12 Min Fahrzeit. Von der Haltestelle 3 Min zu Fuss zur Praxis. Ideal, wenn du das Auto stehen lassen möchtest.",
            "**Mit dem Auto nach Sarmenstorf** (Obere Feldeggstr. 13, 5614 Sarmenstorf): Ab Baden ca. 25 Min via A1 Ausfahrt Lenzburg, dann Kantonsstrasse Richtung Seetal. Parkplätze direkt vor der Praxis, gebührenfrei.",
            "**Mit dem Auto nach Rupperswil**: Ab Baden ca. 20 Min via Wettingen und Aarauerstrasse.",
          ],
        },
        {
          h2: "Warum Kundinnen aus Baden zu uns kommen",
          body: [
            "Baden hat die Thermen – wir haben die individuelle 60-minütige Einzelbehandlung mit persönlichem Vorgespräch. Im Thermalbad bist du eine von vielen, bei uns die einzige Frau im Raum. Ausserdem: Ayurveda arbeitet konstitutionsbezogen – jede Behandlung wird auf deinen Dosha-Typ abgestimmt.",
            "Regelmässige Kundinnen aus dem Raum Baden kommen aus **Baden, Ennetbaden, Wettingen, Neuenhof, Turgi und Nussbaumen**.",
          ],
        },
        {
          h2: "Behandlungen im Überblick",
          body: ["Alle unsere ayurvedischen Behandlungen sind an beiden Standorten verfügbar:"],
          list: [
            "[Abhyanga Ganzkörper-Ölmassage](/behandlungen/abhyanga) – 60 Min · CHF 120",
            "[Kalari-Massage](/massagen) – 60 Min · CHF 120",
            "[Rückenmassage](/massagen) – 60 Min · CHF 120",
            "[Shiroabhyanga (Kopf/Nacken)](/massagen) – 30 Min · CHF 60",
            "[Padabhyanga (Fussmassage)](/massagen) – 30 Min · CHF 60",
            "[Garshana Trocken-Peeling](/massagen) – 45 Min · CHF 100",
            "[Ayurvedische Ernährungs­beratung](/ernaehrung) – ca. 60 Min · auf Anfrage",
          ],
        },
      ],
      faqs: [
        { q: "Wie lange dauert die Anfahrt aus Baden?", a: "Rupperswil per S-Bahn 12 Min. Rupperswil per Auto 20 Min. Sarmenstorf per Auto 25 Min. Umsteigefreie ÖV-Verbindung via S3." },
        { q: "Gibt es Parkmöglichkeiten?", a: "In Sarmenstorf direkt vor der Praxis, kostenlos. In Rupperswil gebührenpflichtige Parkplätze rund um den Bahnhof – deshalb S-Bahn empfohlen." },
        { q: "Welche Behandlung passt zum Einstieg?", a: "Für Erst-Kundinnen aus Baden empfehlen wir die 60-minütige Abhyanga (CHF 120) am Standort Rupperswil – kombiniert mit der entspannten S-Bahn-Anreise ergibt sich fast zwei Stunden echte Auszeit." },
      ],
    },
    en: {
      title: "Ayurveda Baden – Traditional Massages for Women from Baden",
      metaDescription:
        "Ayurveda for women from Baden: practice in Sarmenstorf (25 min) and Rupperswil (12 min by S3 from Baden). Book online from CHF 60.",
      h1: "Ayurveda in Baden – For women from the spa town",
      lead:
        "Baden has been Switzerland's spa town since Roman times. If you're looking for a treatment that goes deeper than a classical massage, our women-only Ayurveda practice is the complement. We're not in Baden itself, but easily reached: **Rupperswil** in 12 min by S3 from Baden station, **Sarmenstorf** in 25 min by car.",
      sections: [
        { h2: "Treatments for women from Baden", body: ["Our practice combines what a spa alone cannot: rhythmic touch with warm oil that resets the autonomic nervous system, plus a singing-bowl ritual that deepens the effect. All six classical treatments are available – from a 30-min head massage (CHF 60) to a 60-min [Abhyanga](/behandlungen/abhyanga) full-body (CHF 120)."] },
        { h2: "Getting here from Baden", body: [
          "**By train to Rupperswil** (Aarestrasse 20): S3 from Baden station, 12 min ride, then 3 min on foot.",
          "**By car to Sarmenstorf** (Obere Feldeggstr. 13): 25 min via A1 exit Lenzburg, then Seetal cantonal road. Free parking at the door.",
          "**By car to Rupperswil**: 20 min via Wettingen and Aarauerstrasse.",
        ] },
        { h2: "Why women from Baden come to us", body: [
          "Baden has the thermal baths – we have the individual 60-minute session with personal intake. In a thermal bath you're one of many; here you're the only woman in the room. Ayurveda is constitution-based: every session is tuned to your dosha.",
          "Regular clients come from Baden, Ennetbaden, Wettingen, Neuenhof, Turgi and Nussbaumen.",
        ] },
        { h2: "Treatments overview", body: ["All treatments are available at both locations:"], list: [
          "[Abhyanga full-body oil massage](/behandlungen/abhyanga) – 60 min · CHF 120",
          "[Kalari massage](/massagen) – 60 min · CHF 120",
          "[Back massage](/massagen) – 60 min · CHF 120",
          "[Shiroabhyanga head & neck](/massagen) – 30 min · CHF 60",
          "[Padabhyanga foot massage](/massagen) – 30 min · CHF 60",
          "[Garshana dry brushing](/massagen) – 45 min · CHF 100",
        ] },
      ],
      faqs: [
        { q: "How long is the trip from Baden?", a: "Rupperswil by S3: 12 min. Rupperswil by car: 20 min. Sarmenstorf by car: 25 min. Direct S3 connection." },
        { q: "Is there parking?", a: "Free parking at the door in Sarmenstorf. Paid parking around Rupperswil station – we recommend the S-Bahn." },
        { q: "What's a good first treatment?", a: "For first-time clients from Baden we recommend a 60-min Abhyanga at Rupperswil, combined with the S-Bahn ride – nearly two hours of real time-out." },
      ],
    },
  },
  wettingen: {
    slug: "wettingen",
    de: {
      title: "Ayurveda Wettingen – Traditionelle Massagen für Frauen | Aargau",
      metaDescription:
        "Ayurveda für Frauen aus Wettingen: Praxis in Rupperswil (15 Min) und Sarmenstorf (22 Min). Termin online buchen. Ab CHF 60.",
      h1: "Ayurveda in Wettingen – Traditionelle Massagen für Frauen",
      lead:
        "Wettingen ist die grösste Gemeinde des Kantons Aargau ohne Stadtrecht – über 20 000 Einwohnerinnen am Fuss der Lägern. Für Frauen aus Wettingen, die nach ayurvedischer Massage suchen, sind wir bequem erreichbar: **Rupperswil** in 15 Min mit dem Auto, **Sarmenstorf** in 22 Min.",
      sections: [
        {
          h2: "Ayurveda-Behandlungen für Kundinnen aus Wettingen",
          body: [
            "Wettingerinnen finden bei uns die klassischen ayurvedischen Behandlungen für Frauen. Anders als bei einer klassischen Massage steht bei Ayurveda das Zusammenspiel von warmem Öl, ruhigem Rhythmus und individueller **Konstitutionsberücksichtigung** (Vata, Pitta, Kapha) im Zentrum.",
          ],
        },
        {
          h2: "Anfahrt aus Wettingen",
          body: [
            "**Mit dem Auto nach Rupperswil** (Aarestrasse 20, 5102 Rupperswil): Ab Wettingen ca. 15 Min via A1 oder Kantonsstrasse Aarauerstrasse. Parkplätze rund um den Bahnhof.",
            "**Mit dem Auto nach Sarmenstorf** (Obere Feldeggstr. 13, 5614 Sarmenstorf): Ab Wettingen ca. 22 Min via A1 Ausfahrt Lenzburg. Parkplätze direkt vor der Praxis, gebührenfrei.",
            "**Mit ÖV nach Rupperswil**: Ab Bahnhof Wettingen mit der S3/S12 nach Rupperswil (ca. 20 Min), dann 3 Min zu Fuss.",
          ],
        },
        {
          h2: "Warum Kundinnen aus Wettingen zu uns kommen",
          body: [
            "Wettingen liegt direkt neben Baden, teilt aber weder die touristische Ausrichtung noch die Preise. Wettingerinnen suchen häufig konkrete Lösungen für konkrete Beschwerden: Rückenschmerzen nach Bildschirmarbeit, Schlafprobleme, Wechseljahresbeschwerden. Ayurveda arbeitet genau hier – nicht symptomatisch, sondern konstitutionsbezogen.",
            "Viele unserer Kundinnen aus Wettingen kombinieren die Praxisbesuche mit der Wanderregion Lägern-Hochwacht.",
          ],
        },
        {
          h2: "Behandlungen im Überblick",
          body: ["Alle unsere ayurvedischen Behandlungen sind an beiden Standorten verfügbar:"],
          list: [
            "[Abhyanga Ganzkörper-Ölmassage](/behandlungen/abhyanga) – 60 Min · CHF 120",
            "[Kalari-Massage](/massagen) – 60 Min · CHF 120",
            "[Rückenmassage](/massagen) – 60 Min · CHF 120",
            "[Shiroabhyanga (Kopf/Nacken)](/massagen) – 30 Min · CHF 60",
            "[Padabhyanga (Fussmassage)](/massagen) – 30 Min · CHF 60",
            "[Garshana Trocken-Peeling](/massagen) – 45 Min · CHF 100",
          ],
        },
      ],
      faqs: [
        { q: "Wie lange dauert die Anfahrt aus Wettingen?", a: "Nach Rupperswil ca. 15 Min mit dem Auto oder 20 Min mit der S-Bahn. Nach Sarmenstorf ca. 22 Min mit dem Auto." },
        { q: "Gibt es Parkmöglichkeiten?", a: "In Sarmenstorf gebührenfreie Parkplätze direkt vor der Praxis. In Rupperswil rund um den Bahnhof (gebührenpflichtig)." },
        { q: "Welche Behandlung passt zum Einstieg?", a: "Für Wettingerinnen mit Bildschirm-Verspannungen empfehlen wir die 60-minütige Rückenmassage. Für alle anderen die klassische Abhyanga." },
      ],
    },
    en: {
      title: "Ayurveda Wettingen – Traditional Massages for Women | Aargau",
      metaDescription:
        "Ayurveda for women from Wettingen: practice in Rupperswil (15 min) and Sarmenstorf (22 min). Book online from CHF 60.",
      h1: "Ayurveda in Wettingen – Traditional massages for women",
      lead:
        "Wettingen is Aargau's largest municipality without city status – 20 000+ residents at the foot of the Lägern ridge. From Wettingen you reach us conveniently: **Rupperswil** in 15 min by car, **Sarmenstorf** in 22 min.",
      sections: [
        { h2: "Treatments for women from Wettingen", body: ["Wettingen women find our classical ayurvedic treatments – with warm oil, quiet rhythm and personal constitution assessment (Vata, Pitta, Kapha). Every session is tuned to you."] },
        { h2: "Getting here from Wettingen", body: [
          "**By car to Rupperswil**: 15 min via A1 or Aarauerstrasse. Parking around the station.",
          "**By car to Sarmenstorf**: 22 min via A1 exit Lenzburg. Free parking at the door.",
          "**By train to Rupperswil**: S3/S12 from Wettingen station (about 20 min), then 3 min on foot.",
        ] },
        { h2: "Why women from Wettingen come to us", body: [
          "Wettingen sits next to Baden but shares neither the tourist focus nor the prices. Women from Wettingen typically seek concrete solutions: back pain from screen work, sleep issues, menopausal symptoms. Ayurveda addresses these constitutionally, not just symptomatically.",
        ] },
        { h2: "Treatments overview", body: ["All treatments are available at both locations:"], list: [
          "[Abhyanga full-body](/behandlungen/abhyanga) – 60 min · CHF 120",
          "[Kalari massage](/massagen) – 60 min · CHF 120",
          "[Back massage](/massagen) – 60 min · CHF 120",
          "[Shiroabhyanga](/massagen) – 30 min · CHF 60",
          "[Padabhyanga](/massagen) – 30 min · CHF 60",
          "[Garshana](/massagen) – 45 min · CHF 100",
        ] },
      ],
      faqs: [
        { q: "How long is the trip from Wettingen?", a: "To Rupperswil ca. 15 min by car or 20 min by train. To Sarmenstorf ca. 22 min by car." },
        { q: "Parking?", a: "Free at the door in Sarmenstorf. Paid around Rupperswil station." },
        { q: "Which treatment to start with?", a: "For screen-tension we recommend the 60-min back massage; otherwise the classic Abhyanga." },
      ],
    },
  },
  "zuerich-umgebung": {
    slug: "zuerich-umgebung",
    de: {
      title: "Ayurveda Zürich Umgebung – Traditionelle Massagen im Aargau",
      metaDescription:
        "Ayurveda für Frauen aus Zürich: Praxis in Rupperswil (30 Min per S-Bahn) und Sarmenstorf (45 Min per Auto). Termin online buchen ab CHF 60.",
      h1: "Ayurveda für Frauen aus Zürich und Umgebung",
      lead:
        "Die Stadt Zürich hat viele Wellness-Angebote – aber eine klassische ayurvedische Massage-Praxis exklusiv für Frauen, mit warmem Öl, Klangschalen-Ritual und individueller Konstitutionsberatung, ist auch in Zürich selten. Frauen aus **Zürich, Dietikon, Regensdorf, Schlieren, Urdorf und dem Limmattal** kommen deshalb regelmässig zu uns.",
      sections: [
        {
          h2: "Ayurveda-Behandlungen für Kundinnen aus Zürich",
          body: [
            "Was uns von den meisten Zürcher Wellness-Studios unterscheidet: **ausschliesslich Frauen als Kundinnen**, kein Grosstermin-Betrieb, keine 30-Minuten-Slots am Fliessband. Jede Behandlung beginnt mit einem persönlichen Vorgespräch und wird auf deine Konstitution abgestimmt. Zusätzlich: ein Klangschalen-Ritual zu Beginn und zum Abschluss.",
          ],
        },
        {
          h2: "Anfahrt aus Zürich",
          body: [
            "**Mit der S-Bahn ab Zürich HB nach Rupperswil** (Aarestrasse 20, 5102 Rupperswil): direkt umsteigefrei via IR oder S3 nach Rupperswil – die schnellste Fahrt ca. 30 Min. Dann 3 Min zu Fuss. **Empfehlung für Frauen aus Zürich**: entspannt hin, entspannt zurück, kein Autostress.",
            "**Mit dem Auto nach Sarmenstorf** (Obere Feldeggstr. 13, 5614 Sarmenstorf): ab Zürich West ca. 45 Min via A1 Ausfahrt Mägenwil. Aus Dietikon 35 Min. Parkplätze direkt vor der Praxis, gebührenfrei.",
            "**Mit dem Auto nach Rupperswil**: ab Zürich ca. 40 Min via A1 Ausfahrt Aarau-Ost.",
          ],
        },
        {
          h2: "Warum Kundinnen aus Zürich zu uns kommen",
          body: [
            "Zürich ist gross, laut und schnell – Ayurveda ist ruhig, langsam und geerdet. Unsere Praxis liegt bewusst in einer kleinen Gemeinde – nicht im «Wellness-Belt» Zürichs, sondern dort, wo die Landschaft schon Teil der Behandlung ist. Frauen aus Zürich schätzen diese Distanz: 30 Min Bahn, während der man das Handy weglegen darf, dann 60 Min Behandlung, dann 30 Min Rückfahrt – zwei Stunden echte Auszeit.",
            "Regelmässige Kundinnen kommen aus Zürich (alle Kreise), Dietikon, Schlieren, Urdorf, Regensdorf, Oerlikon, Wallisellen und Dübendorf.",
          ],
        },
        {
          h2: "Behandlungen im Überblick",
          body: ["Alle Behandlungen sind an beiden Standorten verfügbar:"],
          list: [
            "[Abhyanga Ganzkörper-Ölmassage](/behandlungen/abhyanga) – 60 Min · CHF 120",
            "[Kalari-Massage](/massagen) – 60 Min · CHF 120",
            "[Rückenmassage](/massagen) – 60 Min · CHF 120",
            "[Shiroabhyanga (Kopf/Nacken)](/massagen) – 30 Min · CHF 60",
            "[Padabhyanga (Fussmassage)](/massagen) – 30 Min · CHF 60",
            "[Garshana Trocken-Peeling](/massagen) – 45 Min · CHF 100",
            "[Ayurvedische Ernährungs­beratung](/ernaehrung) – ca. 60 Min · auch online",
          ],
        },
      ],
      faqs: [
        { q: "Wie lange dauert die Anfahrt aus Zürich?", a: "Nach Rupperswil ca. 30 Min per S-Bahn ab Zürich HB. Nach Sarmenstorf ca. 45 Min mit dem Auto." },
        { q: "Gibt es Parkmöglichkeiten?", a: "Sarmenstorf: gebührenfreie Parkplätze direkt vor der Praxis. Rupperswil: gebührenpflichtige Parkplätze rund um den Bahnhof – deshalb S-Bahn empfohlen." },
        { q: "Welche Behandlung passt zum Einstieg?", a: "Für Erst-Kundinnen aus Zürich empfehlen wir eine 60-minütige Abhyanga in Rupperswil, kombiniert mit der S-Bahn-Anreise." },
      ],
    },
    en: {
      title: "Ayurveda Zurich Region – Traditional Massages in Aargau",
      metaDescription:
        "Ayurveda for women from Zurich: practice in Rupperswil (30 min by train) and Sarmenstorf (45 min by car). Book online from CHF 60.",
      h1: "Ayurveda for women from Zurich and around",
      lead:
        "Zurich city has many wellness offers – but a classical women-only ayurvedic massage practice with warm oil, singing-bowl ritual and personal constitution assessment is rare. Women from **Zurich, Dietikon, Regensdorf, Schlieren, Urdorf and the Limmat valley** regularly travel to us.",
      sections: [
        { h2: "Treatments for women from Zurich", body: ["What sets us apart from most Zurich wellness studios: women-only clientele, no assembly-line 30-min slots. Every session starts with a personal intake and is tuned to your constitution. Plus a singing-bowl ritual at start and end."] },
        { h2: "Getting here from Zurich", body: [
          "**By train from Zurich HB to Rupperswil**: direct IR or S3, fastest ride about 30 min. Then 3 min on foot. Our recommendation for women from Zurich.",
          "**By car to Sarmenstorf**: 45 min from Zurich West via A1 exit Mägenwil. From Dietikon 35 min. Free parking at the door.",
          "**By car to Rupperswil**: 40 min via A1 exit Aarau-Ost.",
        ] },
        { h2: "Why women from Zurich come to us", body: [
          "Zurich is big, loud and fast – Ayurveda is quiet, slow and grounded. Our practice sits in a small village, not the Zurich «wellness belt», where the landscape itself is part of the treatment.",
        ] },
        { h2: "Treatments overview", body: ["All treatments are available at both locations:"], list: [
          "[Abhyanga](/behandlungen/abhyanga) – 60 min · CHF 120",
          "[Kalari](/massagen) – 60 min · CHF 120",
          "[Back massage](/massagen) – 60 min · CHF 120",
          "[Shiroabhyanga](/massagen) – 30 min · CHF 60",
          "[Padabhyanga](/massagen) – 30 min · CHF 60",
          "[Garshana](/massagen) – 45 min · CHF 100",
        ] },
      ],
      faqs: [
        { q: "How long from Zurich?", a: "To Rupperswil about 30 min by train from Zurich HB. To Sarmenstorf about 45 min by car." },
        { q: "Parking?", a: "Free at the door in Sarmenstorf. Paid parking around Rupperswil station – train recommended." },
        { q: "First treatment?", a: "For first-time clients from Zurich we recommend a 60-min Abhyanga at Rupperswil combined with the train ride." },
      ],
    },
  },
};
